import { ReactComponent as ExclamationTriangleIcon } from "../../Assets/exclamation-triangle.svg";
import ChatMessage from "../../Components/ChatMessage/ChatMessage";
import ChatMessageComposer from "../../Components/ChatMessageComposer/ChatMessageComposer";
import FormLoading from "../../Components/FormLoading/FormLoading";
import { DOCKED_COMPOSER_HEIGHT } from "../../Components/WidgetChatComposer/WidgetChatComposer";
import { useConfigStore } from "../../Stores/Config";
import { useRouterStore } from "../../Stores/Router";
import { useSessionStore } from "../../Stores/Session";
import { useTicketStore } from "../../Stores/Ticket";
import { sanitizeHtmlHelper } from "../../Helper/SanitizeHtmlHelper";
import "./ConversationLoading.scss";

// While a conversation started from the home ask-input is being created,
// this view renders the exact end-state of the takeoff: the question bubble
// rising out of the docked composer plus a typing indicator. The later swap
// to the real conversation is pixel-identical, so no spinner and no flash.
const ConversationLoading = () => {
  const conversationError = useTicketStore((state) => state.conversationError);
  const pendingAiQuestionText = useTicketStore(
    (state) => state.pendingAiQuestionText,
  );
  const pendingAiQuestionCreatedAt = useTicketStore(
    (state) => state.pendingAiQuestionCreatedAt,
  );
  const pendingComposerMessage = useTicketStore(
    (state) => state.pendingComposerMessage,
  );
  const routerStore = useRouterStore();
  const sessionStore = useSessionStore();

  if (conversationError?.length || !pendingAiQuestionText) {
    return (
      <div className="conversation">
        <div
          className="conversation-messages"
          style={{
            height: "100%",
          }}
        >
          <div className="conversation-messages-loading">
            {conversationError?.length ? (
              <div className="conversation-error">
                <div className="conversation-error-icon">
                  <ExclamationTriangleIcon />
                </div>
                {conversationError}
                <button
                  className="conversation-error-button"
                  onClick={() => {
                    routerStore.popPage();
                  }}
                >
                  {useConfigStore.getState().translateText("kaiSubmitIdeaDone")}
                </button>
              </div>
            ) : (
              <FormLoading />
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="conversation conversation--shell">
      <div
        className="conversation-messages"
        style={{
          height: "100%",
          // Must stay in lockstep with Conversation's own padding-bottom — this
          // shell is a pixel-identical continuation of it, so any drift shows
          // as a jump when the real thread swaps in.
          paddingBottom: `${DOCKED_COMPOSER_HEIGHT + 37}px`,
        }}
      >
        <div className="conversation-shell-question">
          <ChatMessage
            key="pending-question"
            chatMessage={{
              type: "BOT_REPLY",
              data: {
                content: sanitizeHtmlHelper(pendingAiQuestionText ?? ""),
                type: "text",
              },
              createdAt: pendingAiQuestionCreatedAt ?? new Date(),
              session: sessionStore.session ?? undefined,
              // Show the voice player / attachment immediately instead of the
              // "📎 Attachment" placeholder text (suppressed by ChatMessage when
              // an attachment is present).
              attachments: pendingComposerMessage?.attachments,
            }}
            isCreator={true}
            firstOfGroup={true}
            lastOfGroup={true}
            showTime={true}
          />
        </div>
        <div className="conversation-shell-thinking">
          <ChatMessage
            key="pending-typing"
            firstOfGroup={true}
            lastOfGroup={true}
            chatMessage={{
              data: {
                content: "Typing…",
              },
              user: undefined,
              type: "TEXT",
            }}
            forceTyping={true}
            showTime={false}
          />
        </div>
      </div>
      <ChatMessageComposer
        answerBotIsActive
        disabled
        onHeightUpdated={() => {}}
        sendMessage={() => {}}
      />
    </div>
  );
};

export default ConversationLoading;
